import React, {useRef, useState} from "react";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

import PersonalTitleLangs from "./_langs";
import { showToastCustom } from "../../../components/toast/customToast";
import { showLoader } from "../../../components/loader/loader";
import {
    ButtonCancel,
    ButtonNew,
    ButtonSubmit,
    ButtonEdit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { FORM, info, infoMsg } from "../../../components/i18n/i18n";
import { personalTitleService } from "../../../jwt/_services/hotel/personalTitleService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {langProvider} from "../../../providers/langProvider";

const PersonalTitleForm = ( props ) => {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);

    const translatableLangs = savedData?.translatedLangs || []
    const [status, setStatus] = useState(editMode ? props.item?.status : false)
    const [xapiLang, setXapiLang] = useState(editMode ? props.item?.xapiLang?.id : null)
    const [resetValue, setResetvalue] = useState(false)

    //referencia a los langs
    const refLangs = useRef(null);
    const [langChilds, setLangChilds] = useState([]);
    const [childChanges, setChildChanges] = useState( false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    //Para manejar el formulario principal
    const validationSchema = Yup.object().shape({
        code: Yup.string().required('Campo Requerido')
    });

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            code: savedData?.code,
            value: savedData?.value,
            xapiId: savedData?.xapiId,
        }
    });

    const onSubmit = (data, _) => {
        const requestData = {
            fbDataBase:  { id : fbDataBaseId },
            item:{
                ...data,
                status,
                xapiLang
            }
        }

        requestData.item.status = status

        if(xapiLang)
            requestData.item.xapiLang = {id: xapiLang.id}

        if(childChanges)
            requestData.item.langs = addLangs()


        setLoading(true)

        if(!editMode)
            return personalTitleService.saveItem(requestData)
                .then(resultData => setResult(resultData))
                .finally( ()=> setLoading(false) );
        else {
            const id = savedData.id;
            requestData.item.id = savedData?.id

            if (JSON.stringify(savedData) === JSON.stringify(requestData))
                return showToastCustom(info, infoMsg);

            return personalTitleService.updateItem(id, requestData)
                .then(resultData => setResult(resultData))
                .finally( ()=> setLoading(false) );
        }
    };


    const addLangs = () => {
        let dataRequest = [];

        langChilds.map( (langActivity) => {
            const data = {
                id               : langActivity?.id,
                lang             : langActivity?.lang,
                name             : langActivity?.name,
            };

            if(editMode)
                data.personalTitle = { id:  savedData?.id,}

            dataRequest.push(data);
        })

        return dataRequest
    }

    const resetForm = () => {
        setEditMode(false);
        setSavedData(null);
        setSaveSuccess(false);
        setDisableInputs(false);
        setResetvalue(!resetValue)
        setStatus(null)

        refLangs.current.resetForm();
        reset();
    }

    const setForm = () => props.setForm(null, null, "LIST");


    const updateLangChilds = (langChildsP) => {
        if (langChildsP !== undefined) {
            setChildChanges(true);
            setLangChilds(langChildsP);
        }
    }

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
        refLangs.current.changeDisabledInput(true, resultData?.langs);
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        refLangs.current.changeDisabledInput(false, savedData?.langs);
    }


    return(<>
        <Card>
            { loading ? showLoader() : null }
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {
                        editMode && <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>ID</Label>
                                    <Input type="id" name="id" id="id"
                                           disabled
                                           value={editMode ? savedData?.id : ''}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <FormGroup>
                                        <Label>UID Firebase</Label>
                                        <Input type="id" name="uid" id="uid"
                                               disabled
                                               value={editMode ? savedData?.code : ''}
                                        />
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>Código</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder="Código"
                                    innerRef={register}
                                    disabled={editMode}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Valor</Label>
                                <Input
                                    type="text"
                                    name="value"
                                    placeholder="Ingrese el valor"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>XapiId</Label>
                                <Input
                                    type="number"
                                    name="xapiId"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Xapi Lang</Label>
                                <SelectGeneric
                                    initialValue={xapiLang}
                                    setExternalValue={setXapiLang}
                                    provider={langProvider}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    disabled={disableInputs}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>



                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <TranslatedLangs translatableLangs={translatableLangs} />
                        <PersonalTitleLangs
                            key={ "LangKeyId" }
                            ref={ refLangs }
                            setForm={ setForm }
                            editMode={ editMode }
                            personalTitle={ savedData }
                            updateItem={ updateLangChilds }
                            disableInputs={ disableInputs }
                        />
                    </CardBody>




                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={()=>resetForm()}/>
                                    <ButtonEdit onClick={() => beginEdit()}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    </>)
}

export default PersonalTitleForm